import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=cityStrategy&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '城市战略（十五五）',
        pageTitleIcon: '',
        background_img: '',
        description: `华美提供的城市战略咨询服务助力客户把握政策红利与消费升级机遇。当前市场普遍面临战略规划与城市发展脱节、新兴消费需求响应滞后、绿色低碳转型压力剧增等痛点。华美通过区域经济分析与政策解码订制城市酒店战略蓝图，同时将ESG标准融入项目全生命周期，帮助客户在区域高质量发展浪潮中获得先发优势。`,
        icons: [
            {
                name: '城市战略',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/15.城市十五五.pdf'),
                path: "四库赋能-酒店+/城市战略（十五五）/城市战略"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/城市战略（十五五）/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/城市战略（十五五）/数据赋能'),
                path: "四库赋能-酒店+/城市战略（十五五）/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/城市战略（十五五）/全球案例'),
                path: "四库赋能-酒店+/城市战略（十五五）/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/城市战略（十五五）/预警问题'),
                path: "四库赋能-酒店+/城市战略（十五五）/预警问题"
            },
        ]
    }]
}